// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-field[data-v-1d95372a] {\r\n  border-bottom: 1px solid #F2F4F4;\n}\r\n", ""]);
// Exports
module.exports = exports;
